import {  useRef, useState } from 'react';
import './recargas.css';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';

export const Legales = () => {

    const refTexto = useRef('incorrecto');

    const [open, setOpen] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [isActive2, setIsActive2] = useState(false);
    
    const handleClose = () => {
        setOpen(false);
      };

  return (
    <div className='contenedorLegales'>
         <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={open}
                        onClick={handleClose}
                      >
                        <Alert  severity="warning" onClose={() => {}}>{refTexto.current}</Alert>

                      </Backdrop>

          <div className='acoHead' onClick={() => {
            setIsActive(!isActive)
            setTimeout(() => {
                setIsActive2(!isActive2)
          }, 700)}}>
              <div className='titAco'>Legales</div>
              <div className={isActive ? "fleUp" : "fleDown"}></div>
          </div>
          {
            isActive2 &&

            <div className={isActive ? "acoBody animate__animated animate__slideInDown" : "acoBody animate__animated animate__slideOutUp"} >
              <p>Precios incluyen IVA. Consulta disponibilidad de recargas en la página unefon.com.mx. Los beneficios asignados por la recarga realizada, corresponderán a los beneficios vigentes de la oferta en la que se encuentre la línea. Consulta el detalle de tus beneficios en la app Mi Unefon. ©2024 Unefon. Derechos reservados.​</p>
            </div>
          }
          
      </div>
  )
}
